import React, { useEffect, useState } from 'react';
import { Project } from 'new/entities/Project';
import { Stack } from 'new/elements/Stack';
import { ReactComponent as BackArrowIcon } from 'new/components/icons/backArrow.svg';
import { ReactComponent as FolderIcon } from 'new/components/icons/folder.svg';
import { CircularProgress, Link, Typography } from '@mui/material';
import ProjectDetailsActions from 'new/components/pipelines/ProjectsList/ProjectDetailsActions';
import { isManagedResource, isReadOnly } from 'js/lib/ACLUtils';
import { isDetectedDataset } from 'js/lib/ResourceUtils';
import { useAppContext } from 'new/hooks/useAppContext';
import styles from './pipelinesListProjectHeader.module.scss';
import ProjectDetailViewContainer from 'js/components/projects/cards/ProjectDetailViewContainer';

type Props = {
  project: Project;
  length: number;
  isDataFlowsLoading?: boolean;
};

const PipelinesListProjectHeader = ({ project, length, isDataFlowsLoading = false }: Props) => {
  const readOnly = isReadOnly(project);
  const [tab, setTab] = useState();
  const isManaged = isManagedResource(project);
  const isDetected = isDetectedDataset(project);
  const { setCurrentSlug } = useAppContext();

  useEffect(() => {
    if (project?.name) {
      setCurrentSlug(project.name);
    }
  }, [project?.name]);

  const onDetailClicked = (data, tab) => {
    setTab(tab);
  };

  const handleClose = () => {
    setTab('');
  };

  return (
    <Stack
      direction="row"
      spacing="10px"
      alignItems="center"
      justifyContent="space-between"
      className={styles.container}
    >
      <Link to="/integrate/projects">
        <BackArrowIcon />
      </Link>
      <FolderIcon height="32px" width="32px" />
      <Stack flex="1">
        <Typography variant="h2">{project.name}</Typography>
        <Typography variant="body3">{project.description}</Typography>
      </Stack>
      <Stack direction="row" spacing="4px" className={styles.lengthBar}>
        {isDataFlowsLoading ? (
          <CircularProgress size={20} />
        ) : (
          <>
            <div className={styles.circle}>{length || 0}</div>
            <Typography color="primary.dark" variant="bold">
              Data Flows
            </Typography>
          </>
        )}
      </Stack>
      <ProjectDetailsActions
        data={project}
        readOnly={readOnly}
        showStatus={false}
        onDetailClicked={onDetailClicked}
        showTransform
        showSend
        isManaged={isManaged}
        isDetected={isDetected}
      />
      {tab && <ProjectDetailViewContainer type={tab} id={project.id} onClose={handleClose} />}
    </Stack>
  );
};

export default PipelinesListProjectHeader;
